import { render, staticRenderFns } from "./PayOrderPopup.vue?vue&type=template&id=106d1ecb&scoped=true"
import script from "./PayOrderPopup.vue?vue&type=script&lang=js"
export * from "./PayOrderPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106d1ecb",
  null
  
)

export default component.exports